export default {
  active: true,
  blur: true,
  dirty: true,
  dirtySinceLastSubmit: true,
  error: true,
  focus: true,
  invalid: true,
  modified: true,
  pristine: true,
  submitError: true,
  submitFailed: true,
  submitSucceeded: true,
  submitting: true,
  touched: true,
  valid: true,
  validating: true,
  value: true,
  visited: true,
}
